import type { SeriesClickCallbackFunction } from 'highcharts';
import { type FC, useMemo } from 'react';
import { useGetPieChartDefaultOptions } from 'src/components/highcharts';
import { useColourPalette } from 'src/hooks/useColourPalette';

import { HighchartsWidget } from '../../HighchartsWidget';
import type { Props } from './WidgetPieChart';

export const WidgetPieChartHighcharts: FC<Props> = ({
  data,
  donut,
  onSegmentClick,
  showAsPercentage,
}) => {
  const { genericCategoricalPalette } = useColourPalette();
  const pieData = data?.map((d, i) => ({
    title: d.label ?? String(d.x),
    value: d.y as number,
    x: d.x,
    color: d.color ?? genericCategoricalPalette(i),
  }));

  const total = useMemo(
    () =>
      pieData ? (pieData?.reduce((acc, curr) => acc + curr.value, 0) ?? 0) : 0,
    [pieData]
  );

  const onClick: SeriesClickCallbackFunction = (event) =>
    onSegmentClick?.({ value: pieData[event.point.index].x });

  const defaultOptions = useGetPieChartDefaultOptions({
    donut,
    onClick,
    showAsPercentage,
    label: {
      total: total.toString(),
      description: 'Total',
    },
  });

  const options: Highcharts.Options = {
    ...defaultOptions,
    series: [
      {
        type: 'pie',
        data: pieData.map((p) => ({
          name: p.title,
          y: p.value,
          color: p.color,
        })),
      },
    ],
  };

  return <HighchartsWidget options={options} />;
};
